import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=38567ba2&scoped=true&"
import script from "./TaskModal.vue?vue&type=script&lang=js&"
export * from "./TaskModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=38567ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38567ba2",
  null
  
)

export default component.exports